import { render, staticRenderFns } from "./EventPage.vue?vue&type=template&id=352ccebd&scoped=true"
import script from "./EventPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventPage.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EventPage.vue?vue&type=style&index=0&id=352ccebd&prod&lang=scss&scoped=true"
import style1 from "./EventPage.vue?vue&type=style&index=1&id=352ccebd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352ccebd",
  null
  
)

export default component.exports